export default "__VITE_ASSET__13Yf1S6w__"